export default __webpack_public_path__ + "static/media/united-arab-emirates.8cac3e1c.png";